import * as React from 'react';
import IDHelpers from '@/core/helpers/IDHelper';

const StepsToFollow = ({ steps }: { steps: string[] }) => (
  <div>
    <p>
      <strong>Pasos a seguir:</strong>
    </p>
    <div>
      <ul
        style={{
          listStyle: 'auto',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '20px',
          color: '#161D1F',
          marginTop: '12px',
          marginLeft: '20px'
        }}
      >
        {steps.map((step) => (
          <li key={IDHelpers.generateID()}>{step}</li>
        ))}
      </ul>
    </div>
  </div>
);

export default StepsToFollow;
